export const RECLUTAMIENTO = "https://api-reclutamiento.cydocs.cl";
export const STORAGE = "https://storage.cydocs.cl";
export const EMAIL_API_URL = "https://sendmail.cydocs.cl/email";